<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalDialogStore } from '@/stores/use-global-dialog-store'

const { globalDialogData, isDialogShow } = storeToRefs(useGlobalDialogStore())
const { closeGlobalDialog, confirmDialog, cancelDialog } =
  useGlobalDialogStore()
</script>

<template>
  <app-modal
    modal-footer-class="modal-footer border-0"
    :modal-title="globalDialogData?.title"
    :model-value="isDialogShow"
    :size="'lg'"
    @modal-hidden="closeGlobalDialog"
  >
    <div class="w-100 d-flex justify-content-center">
      {{ globalDialogData?.content }}
    </div>
    <template #footer>
      <!-- 確認對話框模式 -->
      <template v-if="globalDialogData?.showConfirmButton">
        <div class="buttons-wrap buttons-row-wrap flex-row">
          <app-button
            class="btn btn-outline-secondary"
            type="button"
            :aria-label="$t('Common.AppModal.Cancel')"
            @click="cancelDialog"
          >
            {{ $t('Common.AppModal.Cancel') }}
          </app-button>
          <app-button
            class="btn btn-primary"
            type="button"
            :aria-label="$t('Common.AppModal.Confirm')"
            @click="confirmDialog"
          >
            {{ $t('Common.AppModal.Confirm') }}
          </app-button>
        </div>
      </template>
      <!-- 一般對話框模式 -->
      <template v-else>
        <div class="buttons-wrap buttons-row-wrap flex-row">
          <app-button
            class="btn btn-outline-primary"
            type="button"
            :aria-label="$t('Common.AppModal.ClosePopup')"
            @click="closeGlobalDialog"
          >
            {{ $t('Common.AppModal.Close') }}
          </app-button>
        </div>
      </template>
    </template>
  </app-modal>
</template>
